import { render, staticRenderFns } from "./detainmentDialog.vue?vue&type=template&id=c6d4e634&scoped=true"
import script from "./detainmentDialog.vue?vue&type=script&lang=js"
export * from "./detainmentDialog.vue?vue&type=script&lang=js"
import style0 from "./detainmentDialog.vue?vue&type=style&index=0&id=c6d4e634&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6d4e634",
  null
  
)

export default component.exports